var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export var ArrowLeftIcon = function (props) {
    var role = 'button';
    var nextProps = __assign(__assign({}, props), { role: role });
    return (React.createElement(SvgIcon, __assign({}, nextProps),
        React.createElement("path", { d: "M6.31478112,12.7153289 C6.30895188,12.7098799 6.30318945,12.7043659 6.29749501,12.6987879 C5.89418026,12.3037227 5.90191952,11.670601 6.31478112,11.2846711 L15.0072619,3.1592162 C15.2343645,2.94692793 15.6025705,2.94692793 15.8296731,3.1592162 C16.0567756,3.37150446 16.0567756,3.71569174 15.8296731,3.92798001 L7.19435606,12 L15.8296731,20.07202 C16.0567756,20.2843083 16.0567756,20.6284955 15.8296731,20.8407838 C15.6025705,21.0530721 15.2343645,21.0530721 15.0072619,20.8407838 L6.31478112,12.7153289 Z" })));
};
//# sourceMappingURL=ArrowLeftIcon.js.map